var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBooks = function SvgBooks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 116 100"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M112 96H13.255C8.696 96 5 92.36 5 87.868v-9.736C5 73.641 8.696 70 13.255 70H112z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECF2FA",
    d: "M5 77.734V83h107V69H13.255C8.695 69 5 72.91 5 77.734"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD040",
    d: "M116 100H12.462C5.591 100 0 94.389 0 87.491V77.51C0 70.61 5.59 65 12.462 65H116v8.34H12.462c-2.29 0-4.154 1.87-4.154 4.169v9.982c0 2.3 1.864 4.17 4.154 4.17H116z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9800",
    d: "M29 100H12.505C5.61 100 0 94.389 0 87.492v-9.984C0 70.611 5.61 65 12.505 65H29v8.339H12.505a4.174 4.174 0 0 0-4.168 4.17v9.983c0 2.299 1.87 4.169 4.168 4.169H29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M100 30H30.243C25.691 30 22 26.36 22 21.868v-9.736C22 7.642 25.69 4 30.243 4H100z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECF2FA",
    d: "M22 12.734V18h78V4H30.243C25.691 4 22 7.91 22 12.734"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1CC979",
    d: "M104 35H29.473C22.596 35 17 29.389 17 22.492v-9.984C17 5.611 22.596 0 29.473 0H104v8.339H29.473a4.17 4.17 0 0 0-4.157 4.17v9.983c0 2.299 1.865 4.169 4.157 4.169H104z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#147C3F",
    d: "M46 35H29.505C22.61 35 17 29.389 17 22.492v-9.984C17 5.611 22.61 0 29.505 0H46v8.339H29.505a4.174 4.174 0 0 0-4.168 4.17v9.983c0 2.299 1.87 4.169 4.168 4.169H46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#366AFF",
    d: "M19 65h89V50H19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#89BFF8",
    d: "M24 65h3V50h-3zM30 65h3V50h-3zM94 65h3V50h-3zM100 65h3V50h-3zM41.5 55.297a2.206 2.206 0 0 0-2.203 2.203c0 1.215.988 2.203 2.203 2.203a2.206 2.206 0 0 0 2.203-2.203 2.206 2.206 0 0 0-2.203-2.203m0 6.703a4.505 4.505 0 0 1-4.5-4.5c0-2.481 2.019-4.5 4.5-4.5s4.5 2.019 4.5 4.5c0 2.482-2.019 4.5-4.5 4.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D83A3A",
    d: "M12 50h89V35H12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A20505",
    d: "M93 50h3V35h-3zM87 50h3V35h-3zM22 50h3V35h-3zM16 50h3V35h-3zM78.5 39.297a2.206 2.206 0 0 0-2.203 2.203c0 1.215.988 2.203 2.203 2.203a2.206 2.206 0 0 0 2.203-2.203 2.206 2.206 0 0 0-2.203-2.203m0 6.703a4.505 4.505 0 0 1-4.5-4.5c0-2.482 2.019-4.5 4.5-4.5s4.5 2.018 4.5 4.5c0 2.481-2.019 4.5-4.5 4.5"
  }))));
};
export default SvgBooks;